<footer class="footer" id="footer" role="contentinfo">

  <div class="footer__container">

    <!-- Main grid -->
    <div class="container footer__grid">

      <!-- Brand column -->
      <div class="footer__brand d-flex flex-column flex-md-row justify-content-between align-items-center">
        <div class="footer__wrapper">
          <a routerLink="/" class="footer__logo mb-3" aria-label="SEERDEX home">
           <img src="/assets/images/svg-icons/logo.svg" alt="SEERDEX logo" loading="lazy" class="img-fluid mwx-150">

          </a>
          <p class="footer__tagline">{{ 'footer_navigation.disclaimer' | translate }}</p>
        </div>
        <div class="footer__social" role="list" aria-label="terms and conditions">
          @for (item of legalLinks; track item.titleKey) {
          <a class="footer__copyright text-grey"
            routerLink="/{{ currentLanguage !== 'en' && currentLanguage !== '' ? `${currentLanguage}/${item.routeLink}` : item.routeLink }}"
            title="{{ item.titleKey }}">
            {{ item.titleKey | translate }}
          </a>
          }
        </div>
        <div class="footer__social" role="list" aria-label="Social media links">
          @for (item of social; track item.text) {
          <a [href]="item.link || '#'" class="footer__social-link text-grey" target="_blank" rel="noopener noreferrer"
            role="listitem" [attr.aria-label]="item.text"
            (click)="trackExternalLink(item.link, item.text.toLowerCase())">
            {{ item.text | translate}}
          </a>
          }
        </div>
      </div>
       <p class="font-10 footer__desc">{{ 'footer_navigation.disclaimer_desc' | translate }}</p>
      <div class="footer__copyright mt-3 text-center">{{ 'footer_navigation.copyright' | translate }}</div>
    </div>
  </div>
</footer>